import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const STORAGE_KEY = "dashboard_sections_open";

const readState = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

export const fmtTL = (v) => `₺${Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const CollapsibleSection = ({ id, title, icon, titleClass = "text-gray-700", summary, children }) => {
  const [open, setOpen] = useState(() => readState()[id] === true);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readState(), [id]: next }));
  };

  return (
    <section className="bg-white border border-gray-200 rounded-xl shadow-sm" data-testid={`dash-section-${id}`}>
      <button
        type="button"
        onClick={toggle}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-gray-50 rounded-xl transition-colors"
        aria-expanded={open}
        data-testid={`dash-section-toggle-${id}`}
      >
        <span className={`text-lg font-semibold flex items-center gap-2 ${titleClass}`}>
          {icon}
          {title}
        </span>
        <span className="flex items-center gap-3">
          {summary && !open && <span className="hidden sm:inline text-sm text-gray-500">{summary}</span>}
          <ChevronDown className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      {open && <div className="px-4 pb-4 pt-1" data-testid={`dash-section-body-${id}`}>{children}</div>}
    </section>
  );
};
